import { render, staticRenderFns } from "./ReviewWidget.vue?vue&type=template&id=dbe355d0&scoped=true"
import script from "./ReviewWidget.vue?vue&type=script&lang=js"
export * from "./ReviewWidget.vue?vue&type=script&lang=js"
import style0 from "./ReviewWidget.vue?vue&type=style&index=0&id=dbe355d0&prod&lang=scss&scoped=true"
import style1 from "./ReviewWidget.vue?vue&type=style&index=1&id=dbe355d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe355d0",
  null
  
)

export default component.exports